export const englishGroceries = {
  templateId: 'groceries',
  language: 'en',
  name: 'Groceries (English)',
  description: 'Common grocery items for UK supermarkets like Tesco, Sainsbury\'s and ASDA',
  icon: '🛒',
  categories: [
    {
      name: 'Meat & Fish',
      items: [
        'Chicken breast',
        'Mince',
        'Pork chops',
        'Bacon',
        'Sausages',
        'Salmon',
        'Cod',
        'Prawns',
        'Chicken thighs',
        'Steak',
        'Ham',
        'Pâté',
        'Burgers',
        'Lamb mince',
        'Trout',
        'Turkey',
        'Duck',
        'Beef mince',
        'Chicken wings',
        'Tuna',
        'Mackerel',
        'Crab',
        'Lobster',
        'Scallops',
        'Mussels'
      ]
    },
    {
      name: 'Dairy',
      items: [
        'Milk',
        'Cheese',
        'Butter',
        'Yogurt',
        'Eggs',
        'Sour cream',
        'Double cream',
        'Cottage cheese',
        'Margarine',
        'Single cream',
        'Greek yogurt',
        'Cheddar',
        'Mozzarella',
        'Brie',
        'Parmesan',
        'Red Leicester',
        'Stilton',
        'Goat cheese',
        'Feta',
        'Camembert',
        'Edam',
        'Gouda',
        'Emmental',
        'Gruyère',
        'Manchego',
        'Whole milk',
        'Semi-skimmed milk',
        'Skimmed milk',
        'Organic milk',
        'Buttermilk',
        'Natural yogurt',
        'Fruit yogurt',
        'Probiotic yogurt',
        'Drinking yogurt',
        'Crème fraîche',
        'Mascarpone',
        'Ricotta',
        'Quark',
        'Fromage frais',
        'Clotted cream',
        'Whipping cream',
        'Aerosol cream',
        'Condensed milk',
        'Evaporated milk',
        'Powdered milk',
        'Egg whites',
        'Duck eggs',
        'Quail eggs',
        'Free-range eggs',
        'Organic eggs'
      ]
    },
    {
      name: 'Fruit & Vegetables',
      items: [
        'Apples',
        'Bananas',
        'Carrots',
        'Onions',
        'Potatoes',
        'Tomatoes',
        'Cucumber',
        'Peppers',
        'Oranges',
        'Lemons',
        'Lettuce',
        'Broccoli',
        'Cauliflower',
        'Parsley',
        'Dill',
        'Celery',
        'Red onions',
        'Garlic',
        'Ginger',
        'Avocado',
        'Grapes',
        'Strawberries',
        'Blueberries',
        'Raspberries',
        'Blackberries',
        'Cherries',
        'Pears',
        'Peaches',
        'Plums',
        'Apricots',
        'Kiwi',
        'Mango',
        'Pineapple',
        'Clementines',
        'Grapefruit',
        'Limes',
        'Watermelon',
        'Honeydew melon',
        'Cantaloupe',
        'Mushrooms',
        'Button mushrooms',
        'Portobello mushrooms',
        'Spinach',
        'Rocket',
        'Watercress',
        'Iceberg lettuce',
        'Cabbage',
        'Red cabbage',
        'Savoy cabbage',
        'Spring onions',
        'Leeks',
        'Fennel',
        'Celery',
        'Chinese cabbage',
        'Beetroot',
        'Parsnips',
        'Pumpkin',
        'Butternut squash',
        'Courgette',
        'Aubergine',
        'Chillies',
        'Jalapeños',
        'Brussels sprouts',
        'Kale',
        'Sweetcorn',
        'Baby sweetcorn',
        'Chives',
        'Basil',
        'Thyme',
        'Rosemary',
        'Coriander',
        'Mint',
        'Tarragon',
        'Sage',
        'Oregano',
        'Radishes',
        'Turnips',
        'Swede',
        'Artichokes',
        'Asparagus',
        'Green beans',
        'Runner beans',
        'Broad beans',
        'Mange tout',
        'Sugar snap peas',
        'Cherry tomatoes',
        'Plum tomatoes',
        'Beef tomatoes',
        'Sweet potatoes',
        'New potatoes',
        'Baby potatoes'
      ]
    },
    {
      name: 'Bread & Bakery',
      items: [
        'Bread',
        'Rolls',
        'Crispbread',
        'Crackers',
        'Buns',
        'Baguette',
        'Pitta bread',
        'Wraps',
        'Bagels',
        'Wholemeal bread',
        'White bread',
        'Croissants',
        'Danish pastries',
        'Muffins'
      ]
    },
    {
      name: 'Frozen',
      items: [
        'Frozen vegetables',
        'Ice cream',
        'Pizza',
        'Fish fingers',
        'Chips',
        'Frozen berries',
        'Fish pie',
        'Lasagne',
        'Frozen peas',
        'Frozen spinach',
        'Frozen chicken',
        'Pancakes',
        'Waffles',
        'Fish cakes',
        'Frozen broccoli',
        'Frozen cauliflower',
        'Frozen Brussels sprouts',
        'Frozen sweetcorn',
        'Frozen carrots',
        'Frozen beans',
        'Frozen mixed vegetables',
        'Frozen stir fry mix',
        'Frozen onions',
        'Frozen peppers',
        'Frozen prawns',
        'Frozen scallops',
        'Frozen salmon',
        'Frozen cod',
        'Frozen haddock',
        'Frozen plaice',
        'Frozen mince',
        'Frozen sausages',
        'Frozen bacon',
        'Frozen chicken breast',
        'Frozen chicken thighs',
        'Frozen chicken wings',
        'Frozen turkey',
        'Frozen lamb',
        'Frozen beef',
        'Frozen roast potatoes',
        'Frozen wedges',
        'Frozen hash browns',
        'Frozen onion rings',
        'Frozen chicken nuggets',
        'Frozen burgers',
        'Frozen pastry',
        'Frozen croissants',
        'Frozen garlic bread',
        'Frozen Yorkshire puddings',
        'Frozen ice lollies',
        'Frozen sorbet',
        'Frozen yogurt',
        'Frozen smoothie packs',
        'Frozen strawberries',
        'Frozen raspberries',
        'Frozen blackberries',
        'Frozen blueberries',
        'Frozen mango',
        'Frozen pineapple',
        'Frozen tropical fruit mix',
        'Frozen rhubarb',
        'Frozen apple slices'
      ]
    },
    {
      name: 'Dry Goods',
      items: [
        'Pasta',
        'Rice',
        'Flour',
        'Sugar',
        'Salt',
        'Tinned food',
        'Cereal',
        'Porridge oats',
        'Pepper',
        'Oregano',
        'Basil',
        'Macaroni',
        'Spaghetti',
        'Tinned tomatoes',
        'Beans',
        'Sweetcorn',
        'Oil',
        'Vinegar',
        'Mustard',
        'Mayonnaise',
        'Quinoa',
        'Bulgur wheat',
        'Couscous',
        'Lentils',
        'Chickpeas',
        'Pearl barley',
        'Basmati rice',
        'Jasmine rice',
        'Wild rice',
        'Brown rice',
        'Arborio rice',
        'Rice noodles',
        'Egg noodles',
        'Udon noodles',
        'Soba noodles',
        'Lasagne sheets',
        'Penne',
        'Fusilli',
        'Farfalle',
        'Tagliatelle',
        'Linguine',
        'Ravioli',
        'Gnocchi',
        'Polenta',
        'Sesame seeds',
        'Sunflower seeds',
        'Pumpkin seeds',
        'Flax seeds',
        'Chia seeds',
        'Almonds',
        'Walnuts',
        'Hazelnuts',
        'Pistachios',
        'Pecans',
        'Cashews',
        'Brazil nuts',
        'Macadamia nuts',
        'Pine nuts',
        'Raisins',
        'Dates',
        'Figs',
        'Dried apricots',
        'Dried cranberries',
        'Olive oil',
        'Sunflower oil',
        'Vegetable oil',
        'Coconut oil',
        'Sesame oil',
        'Balsamic vinegar',
        'White wine vinegar',
        'Red wine vinegar',
        'Apple cider vinegar',
        'Honey',
        'Maple syrup',
        'Agave syrup',
        'Golden syrup',
        'Treacle',
        'Vanilla extract',
        'Cinnamon',
        'Cardamom',
        'Nutmeg',
        'Ground ginger',
        'Paprika',
        'Cumin',
        'Coriander seeds',
        'Curry powder',
        'Garam masala',
        'Turmeric',
        'Cayenne pepper',
        'Smoked paprika',
        'Bay leaves',
        'Cloves',
        'Star anise',
        'Garlic powder',
        'Onion powder',
        'Mixed herbs',
        'Italian seasoning',
        'Herbs de Provence'
      ]
    },
    {
      name: 'Drinks',
      items: [
        'Coffee', 'Tea', 'Juice', 'Soft drinks', 'Pepsi Max', 'Pepsi', 'Coca-Cola', 'Coca-Cola Zero', 'Solo', 'Fanta', 'Sprite', 'Urge', 'Mountain Dew', 'Red Bull', 'Battery', 'Tonic water', 'Ginger ale', 'Lemonade',
        'Beer', 'Pilsner', 'IPA', 'Pale Ale', 'Lager', 'Stout', 'Porter', 'Wheat beer', 'Cider', 'Radler', 'Alcohol-free beer',
        'Wine', 'Red wine', 'White wine', 'Rosé wine', 'Champagne', 'Prosecco',
        'Sparkling water', 'Orange juice', 'Apple juice', 'Hot chocolate', 'Energy drinks', 'Squash', 'Milk (drinking)', 'Low alcohol beer', 'Still water', 'Cranberry juice', 'Grape juice', 'Pineapple juice', 'Tomato juice',
        'Green tea', 'Black tea', 'Earl Grey', 'Herbal tea', 'Camomile tea', 'Peppermint tea', 'Instant coffee', 'Ground coffee', 'Coffee beans', 'Decaf coffee', 'Espresso',
        'Soda water', 'Coconut water', 'Sports drinks', 'Smoothies', 'Protein shakes',
        'Spirits', 'Whisky', 'Vodka', 'Gin', 'Rum', 'Brandy', 'Liqueurs'
      ]
    },
    {
      name: 'Snacks & Sweets',
      items: [
        'Chocolate',
        'Biscuits',
        'Crisps',
        'Nuts',
        'Sweets',
        'Cookies',
        'Popcorn',
        'Pretzels',
        'Granola bars',
        'Fruit snacks',
        'Ice cream cones',
        'Jelly',
        'Chewing gum',
        'Mints',
        'Cake',
        'Donuts',
        'Crackers',
        'Trail mix',
        'Protein bars',
        'Rice cakes',
        'Dark chocolate',
        'Milk chocolate',
        'White chocolate',
        'Chocolate bars',
        'Chocolate chips',
        'Digestive biscuits',
        'Ginger biscuits',
        'Shortbread',
        'Wafers',
        'Marshmallows',
        'Toffee',
        'Fudge',
        'Caramels',
        'Gummy bears',
        'Wine gums',
        'Fruit pastilles',
        'Mint imperials',
        'Boiled sweets',
        'Lollipops',
        'Salted peanuts',
        'Cashews',
        'Almonds',
        'Walnuts',
        'Hazelnuts',
        'Pistachios',
        'Mixed nuts',
        'Peanut butter',
        'Almond butter',
        'Honey roasted peanuts',
        'Cheese crackers',
        'Oatcakes',
        'Water biscuits',
        'Breadsticks',
        'Tortilla chips',
        'Potato chips',
        'Corn chips',
        'Vegetable crisps',
        'Pork scratchings',
        'Cereal bars',
        'Flapjacks',
        'Muesli bars'
      ]
    },
    {
      name: 'Cleaning & Personal Care',
      items: [
        'Washing up liquid',
        'Fabric softener',
        'Toilet paper',
        'Soap',
        'Shampoo',
        'Toothpaste',
        'Toothbrush',
        'Washing powder',
        'All-purpose cleaner',
        'Kitchen roll',
        'Deodorant',
        'Shaving foam',
        'Nappies',
        'Sanitary products',
        'Condoms',
        'Laundry tablets',
        'Fabric conditioner',
        'Stain remover',
        'Bleach',
        'Disinfectant',
        'Window cleaner',
        'Bathroom cleaner',
        'Toilet cleaner',
        'Floor cleaner',
        'Furniture polish',
        'Oven cleaner',
        'Washing machine cleaner',
        'Dishwasher tablets',
        'Rinse aid',
        'Salt (dishwasher)',
        'Sponges',
        'Cleaning cloths',
        'Rubber gloves',
        'Bin bags',
        'Cling film',
        'Aluminium foil',
        'Baking paper',
        'Tissues',
        'Wet wipes',
        'Baby wipes',
        'Hand soap',
        'Hand sanitizer',
        'Body wash',
        'Conditioner',
        'Hair gel',
        'Hair spray',
        'Moisturizer',
        'Sunscreen',
        'After shave',
        'Perfume',
        'Cologne',
        'Mouthwash',
        'Dental floss',
        'Razor blades',
        'Shaving gel',
        'Tampons',
        'Pads',
        'Panty liners',
        'Pregnancy tests',
        'Vitamins',
        'Paracetamol',
        'Ibuprofen',
        'Aspirin',
        'Plasters',
        'Antiseptic cream',
        'Eye drops',
        'Contact lens solution'
      ]
    }
  ]
};
